import { connect } from 'react-redux';

import LocalText from '../../../localization/local_text';

function SelectLanguage({ mode, siteMap, handleSelectLanguage }) {
  return (
    <ul id="header-lang" className={`subGnb_dp2 ${siteMap && 'siteMapMode'}`}>
      <li className="subGnb_dp2_list">
        <button className={`subGnb_link ${mode === 'ko' && 'on'}`} onClick={() => handleSelectLanguage('ko')}>
          <LocalText txt={'header_kor'} />
        </button>
      </li>
      <li className="subGnb_dp2_list">
        <button className={`subGnb_link ${mode === 'en' && 'on'}`} onClick={() => handleSelectLanguage('en')}>
          <LocalText txt={'header_eng'} />
        </button>
      </li>
    </ul>
  );
}

const mapStateToProps = (state) => ({ mode: state.mode, siteMap: state.siteMap });

export default connect(mapStateToProps, (dispatch) => ({
  handleSelectLanguage: (mode) => {
    dispatch({ type: 'CHANGE_MODE', mode: mode });

    const url = new URL(window.location);
    url.searchParams.set('lang', mode);

    window.location.replace(url);
  },
}))(SelectLanguage);
